import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { TimeZoneData } from 'src/types/ViewModel/TimeZoneData';
import { PortName } from 'src/types/ViewModel/Stowage/Port/PortName';
import type { LocalPortCall } from './localAolGenerator';
import { compareLocalPortCalls } from './localPortCallUtils';

// Merge two rotation port call lists (e.g., IMOS + StowagePlan) preferring stowage plan data when overlapping on imosPortCallId
export const deriveLocalPortCalls = (
    imosPortCalls: RotationPortCall[] | null | undefined,
    stowagePlanPortCalls: RotationPortCall[] | null | undefined,
    timeZoneData?: TimeZoneData | null,
    portNameList?: readonly PortName[] | null
): LocalPortCall[] => {
    const map = new Map<number, RotationPortCall>();
    const add = (pcs: RotationPortCall[] | null | undefined, preferExisting: boolean) => {
        if (!pcs) return;
        pcs.forEach((pc) => {
            if (!pc.imosPortCallId) return; // ignore synthetic without linkage for now
            if (!map.has(pc.imosPortCallId) || !preferExisting) {
                map.set(pc.imosPortCallId, pc);
            }
        });
    };

    // First add IMOS (baseline), then overlay stowage (preferExisting=false so it overwrites)
    add(imosPortCalls, true);
    add(stowagePlanPortCalls, false);

    const result: LocalPortCall[] = [];
    const portNamesById = new Map((portNameList ?? []).map((portName) => [portName.portId, portName]));
    map.forEach((pc) => {
        const berthCallIds = pc.berthCalls?.filter((bc) => bc.imosBerthCallId != null && bc.berthId).map((bc) => bc.imosBerthCallId!) || [];
        const timeZoneList = timeZoneData?.[pc.portId] || [];
        const portName = portNamesById.get(pc.portId);

        result.push({
            imosPortCallId: pc.imosPortCallId!,
            port: {
                name: pc.portDisplayName || portName?.name || '',
                portId: pc.portId,
                portClusterName: portName?.portClusterName ?? null,
                timeZoneList,
            },
            voyageNumber: pc.voyageNumber,
            portOrderNumber: pc.portOrderNumber,
            imosPortFunction: pc.imosPortFunction,
            berthCallIds: berthCallIds.length > 0 ? berthCallIds : undefined,
        });
    });

    return result.sort(compareLocalPortCalls);
};
